var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',[(!_vm.healthData)?_c('loader'):[_c('dl',{staticClass:"sections"},_vm._l((_vm.healthData.checkResults),function(check,checkIndex){return _c(check.name,{key:checkIndex,tag:"component",attrs:{"check":check}})}),1)]],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex-apart"},[_c('div',[_c('h1',{staticClass:"alpha heavy"},[_vm._v("Health Monitor")])])])
}]

export { render, staticRenderFns }